import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import { WorksheetPageIndex } from 'services/worksheet/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { makeSelectProductWitholdingPeriodDays } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    productId: FertilizerProductId;
}

type Props = OwnProps;

export default function ProductWitholdingPeriodDaysTableCell(
    props: Props
): React.ReactElement {
    const productWitholdingPeriodDays = useSelector((state: AppState) =>
        makeSelectProductWitholdingPeriodDays()(state, props)
    );

    return <TableCell>{productWitholdingPeriodDays}</TableCell>;
}
